import thread from '../shared/thread.js';

export default thread('Window');
